"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OBJECTID_REGEX = exports.EMAIL_REGEX = void 0;
exports.email = email;
exports.objectid = objectid;
const EMAIL_REGEX = exports.EMAIL_REGEX = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
const OBJECTID_REGEX = exports.OBJECTID_REGEX = /^[0-9a-f]{24}$/;
function email(str) {
  return EMAIL_REGEX.test(str);
}
function objectid(str) {
  return OBJECTID_REGEX.test(str);
}